
/**
 * Initial state
 */
export const initialState = {
  isOpen: false,
  sharePath: '',
  socialText: '',
  title: '',
  description: '',
  type: '',
  id: undefined,
};

/**
 * Constants
 */
const SHARING_OPEN = 'SHARING_OPEN';
const SHARING_CLOSE = 'SHARING_CLOSE';

/**
 * Action creators
 */
 export function openShareDialog(sharePath, shareText, title, description, type, id) {
  return {
    type: SHARING_OPEN,
    payload: {
      sharePath,
      socialText: shareText,
      title,
      description,
      type,
      id,
    },
  };
}

export function closeShareDialog() {
  return {
    type: SHARING_CLOSE,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SHARING_OPEN]: (state, action) => ({
    ...state,
    isOpen: true,
    ...action.payload,
  }),
  [SHARING_CLOSE]: (_state, _action) => ({
    ...initialState,
  }),
};

/**
 * Reducer
 *
 * @param {state} state
 * @param {*} action
 * @returns
 */
const reducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}

export default reducer;
